import React from 'react';
import { Link } from 'react-router-dom';

import carolyn_testimonial from '../../content/images/carolyn-testimonial.png';
import galia_testimonial from '../../content/images/galia-testimonial.png';
import jessica_testimonial from '../../content/images/jessica-testimonial.png';
import dgl_with_boy from '../../content/images/dgl-with-boy.jpg';
import grade_graph from '../../content/images/grade-graph.png';
import icon1 from '../../content/images/icon-1.png';
import icon2 from '../../content/images/icon-2.png';
import icon3 from '../../content/images/icon-3.png';

function Home() {
    return (
        <React.Fragment>
            <link rel="stylesheet" type="text/css" href="/styles/home.css" />

            <div class="home-title-image">
                <h1 class="home-title-main remove-underline pt-0">Great Leaps Digital Reading Program</h1>
                <h3 class="home-subtitle-main">Speed. Accuracy. Comprehension.</h3>
                <div class="row">
                    <div class="col-md-3 offset-md-3">
                        <Link to="/about/the-program" class="link-button-h">Learn More <span class="fas fa-chevron-right arrow-icon-header"></span></Link>
                    </div>
                    <div class="col-md-3">
                        <Link to="/account/sign-up" class="link-button-h">Free Trial <span class="fas fa-chevron-right arrow-icon-header"></span></Link>
                    </div>
                </div>
            </div>

            <div class="content-section-w section-mid">
                <div class="row">
                    <h1 class="home-content-title remove-underline">Join over 600,000 students who have made Great Leaps with our programs!</h1>
                </div>
                <div class="row">
                    <div class="col-md-4">
                        <span class="home-circle">
                            <img src={icon1} width="100" height="100" />
                        </span>
                        <h3>Phonics</h3>
                        <p class="icon-text">Systematically teaches students essential phonics skills to full understanding (proficiency).</p>
                    </div>

                    <div class="col-md-4">
                        <span class="home-circle">
                            <img src={icon2} width="100" height="100" />
                        </span>
                        <h3>Sight Phrases</h3>
                        <p class="icon-text">Builds reading speed and accuracy through eliminating high frequency word errors.</p>
                    </div>

                    <div class="col-md-4">
                        <span class="home-circle">
                            <img src={icon3} width="100" height="100" />
                        </span>
                        <h3>Stories</h3>
                        <p class="icon-text">Develops fluent reading with proper intonation and comprehension through fun and engaging age-appropriate stories.</p>
                    </div>
                </div>
            </div>

            <div class="content-section-g section-pic-left">
                <div class="row">
                    <div class="col-sm-12 col-md-6 vcenter home-row-image-container" style={{ "padding-left": "10px 20px" }}>
                        <img src={dgl_with_boy} class="home-row-image" />
                    </div>
                    <div class="col-sm-12 col-md-6 vcenter section-text">
                        <h2 class="section-title">Digital Reading Intervention</h2>
                        <ul class="check-mark-list text-left">
                            <li>For schools, tutors or parents teaching K-12 students that read below the 5th Grade Level who may have learning disabilities such as dyslexia or ADHD</li>
                            <li>Well recognized for over 20 years as a premier <Link to="/about/research" style={{ "text-decoration": "underline" }}>research and evidence</Link> based reading intervention</li>
                            <li>All it takes is 15 minutes a day, three to five days per week with one on one instruction</li>
                        </ul>
                        <Link to="/about/the-program" class="link-button-body float-right home-as" style={{ "padding-bottom": "10px" }}>Learn More <span class="fas fa-chevron-right arrow-icon"></span></Link>
                    </div>
                </div>
            </div>

            <div class="content-section-w section-pic-right">
                <div class="row">
                    <div class="col-md-6 vcenter section-text">
                        <h2 class="section-title">The Results</h2>
                        <ul class="check-mark-list text-left">
                            <li>Our students have averaged a full year of reading growth with just 22 total hours of instruction</li>
                            <li>Parents and teachers report a decrease in behavioral referrals and academic frustration in the home</li>
                            <li>Fluent reading generalizes to improvements in all other areas of academics and standardized testing</li>
                        </ul>
                        <Link to='/about/research' class="link-button-body float-left home-as">Research & Evidence <span class="fas fa-chevron-right arrow-icon"></span></Link>
                    </div>
                    <div class="col-md-6 vcenter">
                        <img src={grade_graph} id="home-grade-graph" />
                    </div>
                </div>
            </div>

            <div id="carouselTestimonials" class="carousel slide" data-ride="carousel"
data-interval="500000">
    <ol class="carousel-indicators">
        <li data-target="#carouselTestimonials" data-slide-to="0" class="active"></li>
        <li data-target="#carouselTestimonials" data-slide-to="1"></li>
        <li data-target="#carouselTestimonials" data-slide-to="2"></li>
    </ol>
    <div class="carousel-inner alt-background-color">
        <div class="item active carousel-item">
            <div class="carousel-caption">
                <div class="col-lg-4 vcenter testimonial-left">
                    <div class="row">
                        <img class="testimonial-image" src={carolyn_testimonial} />
                    </div>
                    <div>
                        <p class="testimonial-attribution">- Carolynn K.
                            <br />Parent
                            <br /><span style={{ visibility:"hidden"}}>.</span>
                        </p>
                    </div>
                </div>
                <div class="col-lg-8 vcenter">
                    <p class="testimonial-statement">&quot;My child is excelling, and looks forward to his next steps in education
                        in middle school. To say Great Leaps has changed my son&apos;s life and
                        future is an UNDERSTATEMENT... Just think, a child&apos;s success in life
                        can be directly impacted by this program in only fifteen minutes a day!&quot;</p>
                </div>
            </div>
        </div>
        <div class="item carousel-item">
            <div class="carousel-caption">
                <div class="col-lg-4 vcenter testimonial-left">
                    <div class="row">
                        <img class="testimonial-image" src={galia_testimonial} />
                    </div>
                    <div>
                        <p class="testimonial-attribution">- Galia M.
                            <br />Executive Director, A.H.A.V.A. English LIteracy Program</p>
                    </div>
                </div>
                <div class="col-lg-8 vcenter">
                    <p class="testimonial-statement">&#x201C;I must reiterate to you how wonderful I think your program is.
                        I have close to 30 years of teaching behind me and this is a program that
                        I think is really worth every bit of hype it gets, and does what it sets
                        out to do.&#x201D;</p>
                </div>
            </div>
        </div>
        <div class="item carousel-item">
            <div class="carousel-caption">
                <div class="col-lg-4 vcenter testimonial-left">
                    <div class="row">
                        <img class="testimonial-image" src={jessica_testimonial} />
                    </div>
                    <div>
                        <p class="testimonial-attribution">- Jessica H.
                            <br />Parent
                            <br /><span style={{visibility: 'hidden' }}>.</span>
                        </p>
                    </div>
                </div>
                <div class="col-lg-8 vcenter">
                    <p class="testimonial-statement">&#x201C;My 8 year old has been doing Great Leaps for 7 weeks now. We started
                        at the end of the school year, had lots of family in town and went on a
                        month long vacation as a family. Through all of that it has been so easy
                        and fun to continue Great Leaps. It&#x2019;s even more fun because of the
                        results I am seeing in Elsie. At 3 weeks I was seeing her self correct.
                        I was ecstatic!&#x201D;</p>
                </div>
            </div>
        </div>
    </div>
    <a class="carousel-control-prev" href="#carouselTestimonials" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon fas fa-chevron-left carousel-control" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
    </a>
    <a class="carousel-control-next" href="#carouselTestimonials" role="button" data-slide="next">
        <span class="carousel-control-next-icon fas fa-chevron-right carousel-control" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
    </a>
</div>
<div class="row alt-background-color">
    <div class="col-3 col-md-4 offset-sm-3 col-lg-4 offset-md-3"></div>
    <div class="col-6 col-md-4 col-lg-4"> <Link to="/about/testimonials" class="link-button-body float-left home-as testimonial-link">View Testimonials <span class="fas fa-chevron-right arrow-icon"></span></Link>
    </div>
</div>


            <div class="content-section-w section-mid youtube-section">
            <h1 class="remove-underline section-title-yt">Student Success Stories</h1>
                <div class="row">
                    <div class="col-sm-6 col-md-3">
                        <h2>Ansley's Story</h2>
                        <div class="embed-responsive embed-responsive-16by9">
                            <iframe src="https://www.youtube-nocookie.com/embed/hkRU8Li-FoM" allowfullscreen></iframe>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-3">
                        <h2>Rachel’s Story</h2>
                        <div class="embed-responsive embed-responsive-16by9">
                            <iframe src="https://www.youtube-nocookie.com/embed/FeJZqPKUQLg" allowfullscreen></iframe>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-3">
                        <h2>Lily’s Story</h2>
                        <div class="embed-responsive embed-responsive-16by9">
                            <iframe src="https://www.youtube-nocookie.com/embed/by4WNVwoJcc" allowfullscreen></iframe>
                        </div>
                    </div>

                    <div class="col-sm-6 col-md-3">
                        <h2>Devonte’s Story</h2>
                        <div class="embed-responsive embed-responsive-16by9">
                            <iframe src="https://www.youtube-nocookie.com/embed/gJ2NbkT5C4s" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>

        </React.Fragment>
    );
};

export default Home;
